import React, { useState, useEffect } from 'react';
import { Button, Col, Container, Form, Modal, Row, Spinner } from 'react-bootstrap';
import close from '../../../assets/images/icons/close.png';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { coachEditCaseStudy } from "../../../utils/api";

const validationSchema = Yup.object().shape({
  problem_issues: Yup.string().required('Problem or issues are required'),
  solution: Yup.string().required('Solution is required'),
  implementation: Yup.string().required('Implementation is required'),
  image: Yup.mixed().notRequired(), // Image is optional for edit
});

function EditCaseStudyModal(props) {
  const [imagePreview, setImagePreview] = useState(null);
  const [file, setfile] = useState(null);

  useEffect(() => {
    if (props?.editData?.image) {
      setImagePreview(props.editData.image); // Load existing image URL
    }
  }, [props.editData]);

  const handleImageChange = (event, setFieldValue) => {
    const file = event.target.files[0];
    console.log('file',file);
    setfile(file)
    if (file) {
      setFieldValue('image', file);
      const reader = new FileReader();
      reader.onload = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const removeImage = (setFieldValue) => {
    setImagePreview(null);
    setFieldValue('image', null);
  };

  const onSubmit = async (values, { setSubmitting }) => {
    const formData = new FormData();
    console.log(values);
    formData.append('problem_issues', values.problem_issues);
    formData.append('solution', values.solution);
    formData.append('implementation', values.implementation);
    /*if (values.image) {
      formData.append('image', values.image);
    }*/
    if (file && imagePreview) {
      //formData.append('type', 'Photo')
      formData.append('isDocChanged', 'yes')
      formData.append('file', file)
    }
    if (!file) {
        formData.append('isDocChanged', 'no')
    }
    await coachEditCaseStudy(props?.editData?.id, formData);
    props.getData();

    // Clear form and close modal after successful submission
    setSubmitting(false);
    props.onHide();
    setImagePreview(null);
    setfile(null);
  };

  return (
    <Modal {...props} size="md" aria-labelledby="contained-modal-problem_issues-vcenter" centered>
      <div className="brand_bg_color1 my_light_modal">
        <Container>
          <Row className="justify-content-center">
            <Col sm="12">
              <div className="ls_modal_conatiner">
                <Button className="ls_mdl_close_btn p-0" onClick={props.onHide}>
                  <img src={close} alt="" />
                </Button>
                <div className="text-start">
                  <h6 className="fs-20 fw-500 text_brand_color2">Edit Case Study</h6>
                </div>
              </div>
            </Col>
            <Formik
              initialValues={{
                problem_issues: props.editData?.problem_issues || '',
                solution: props.editData?.solution || '',
                implementation: props.editData?.implementation || '',
                image: null,
              }}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({ errors, touched, setFieldValue, values, handleSubmit, isSubmitting }) => (
                <Form onSubmit={handleSubmit}>
                  <Col sm="12">
                    <Form.Group className="mb-3 mt-2" controlId="problem_issues">
                      <Form.Label>Problem or Issue</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows="4"
                        name="problem_issues"
                        placeholder="Problem you solved"
                        value={values.problem_issues}
                        isInvalid={touched.problem_issues && !!errors.problem_issues}
                        onChange={(e) => setFieldValue("problem_issues", e.target.value)}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.problem_issues}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group className="mb-3 mt-2" controlId="solution">
                      <Form.Label>Solution</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows="4"
                        name="solution"
                        placeholder="Solution to address the problem or issue"
                        value={values.solution}
                        isInvalid={touched.solution && !!errors.solution}
                        onChange={(e) => setFieldValue("solution", e.target.value)}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.solution}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group className="mb-3 mt-2" controlId="implementation">
                      <Form.Label>Implementation</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows="4"
                        name="implementation"
                        placeholder="Outline the steps that need to be taken to implement the recommended solution"
                        value={values.implementation}
                        isInvalid={touched.implementation && !!errors.implementation}
                        onChange={(e) => setFieldValue("implementation", e.target.value)}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.implementation}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group className="mb-3 mt-2" controlId="image">
                      <Form.Label>Upload Image</Form.Label>
                      <Form.Control
                        type="file"
                        name="image"
                        accept="image/*"
                        onChange={(e) => handleImageChange(e, setFieldValue)}
                        isInvalid={touched.image && !!errors.image}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.image}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  {imagePreview && (
                    <Col sm="12" className="mb-3">
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <img
                          src={imagePreview}
                          alt="Preview"
                          style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: '5px' }}
                        />
                        <Button
                          variant="danger"
                          style={{
                            position: 'absolute',
                            top: '5px',
                            right: '5px',
                            padding: '2px 6px',
                            fontSize: '12px',
                          }}
                          onClick={() => removeImage(setFieldValue)}
                        >
                          ✕
                        </Button>
                      </div>
                    </Col>
                  )}
                  <Col sm="12" className="text-end">
                   {/*<Button className="px-5" variant="success" type="submit">
                      Save
                    </Button>*/}
                    <Button className="px-5" variant="success" type="submit" disabled={isSubmitting}>
                      {isSubmitting ? (
                        <>
                          <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                          />{' '}
                           Updating...
                        </>
                      ) : (
                      'Update'
                    )}</Button>
                  </Col>
                </Form>
              )}
            </Formik>
          </Row>
        </Container>
      </div>
    </Modal>
  );
}

export default EditCaseStudyModal;
